import styled, { css } from 'styled-components'
import Button from '~/components/Buttons/Button'
import { ImageFormat } from './GenericObjectCard.types'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const Header = styled.header<{
  isImageFramed: boolean
}>`
  margin-bottom: 0.5rem;
  ${({ isImageFramed }) =>
    !isImageFramed &&
    `
    display: grid;
    grid-template-columns: 2fr 3fr;
    grid-gap: 1rem;
    justify-items: end;
  `}
`

export const Title = styled.h3`
  color: #303032;
  font-family: Barlow;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2rem;
`

export const Description = styled.p<{ $lines: number }>`
  color: #303032;
  font-family: Barlow;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  margin: 0;
  text-align: justify;
  flex: 1;

  ${({ $lines }) =>
    $lines > 0 &&
    css`
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      -webkit-line-clamp: ${$lines};
      text-overflow: ellipsis;
    `}
`

export const Buttons = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(50% - 0.25rem), 1fr));
  grid-gap: 0.5rem;
  margin-top: 0.5rem;
`

export const StyledButton = styled(Button)`
  max-width: 128px;
`

export const ImageWrapper = styled.div<{
  imageHeight?: string
}>`
  width: 100%;
  height: ${({ imageHeight }) => (imageHeight ? imageHeight : '100%')};

  img {
    height: 100%;
  }
`

export const FramedImageWrapper = styled.div<{
  imageHeight?: string
  imageFormat?: ImageFormat
}>`
  height: ${({ imageHeight }) => (imageHeight ? imageHeight : '145px')};
  overflow: hidden;
  position: relative;
  border-radius: ${({ imageFormat }) =>
    imageFormat === 'circle' ? '50%' : '6px'};
  width: ${({ imageFormat, imageHeight }) =>
    imageFormat === 'circle' ? (imageHeight ? imageHeight : '145px') : 'auto'};
  border: 1px solid #c9c9cb;

  ${({ imageFormat }) =>
    imageFormat === 'circle' &&
    `
    margin: 0 auto;`}

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
